type ConfirmValidationDialogProps = {
    onConferma: () => void;
    onAnnulla: () => void;
  };
  
  export const ConfirmValidationDialog = ({ onConferma, onAnnulla }: ConfirmValidationDialogProps) => {
    return (
      <div className="text-left">
        <h2 className="text-xl font-semibold mb-4 text-center">
          Sei sicuro di voler validare?
        </h2>
        <div className="flex justify-between mt-6">
          <div>
            <button
              onClick={onAnnulla}
              className="px-4 py-2 bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover rounded"
            >
              Annulla
            </button>
          </div>
          <div>
            <button
              onClick={onConferma}
              className="px-4 py-2 bg-textPrimary text-white hover:bg-textSecondary rounded"
            >
              Valida
            </button>
          </div>
        </div>
      </div>
    );
  };
  